import { Component, OnChanges, Input, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { AbstractControl, FormControl } from '@angular/forms';

@Component({
    selector: 'app-time-duration-picker',
    templateUrl: './time-duration-picker.component.html',
    styleUrls: ['./time-duration-picker.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TimeDurationPickerComponent implements OnChanges {
  @Input() isReadonly: boolean = false;
  @Input() control: AbstractControl;
  hours: number = 0;
  minutes: number = 0;

  ngOnInit() {
    this.updateTimeFromControl();
    this.control.valueChanges.subscribe((value: number) => {
      this.hours = Math.floor(value / 60);
      this.minutes = value % 60;
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['control']) {
      this.updateTimeFromControl();
    }
  }

  private updateTimeFromControl() {
    const totalMinutes = this.control.value || 0;
    this.hours = Math.floor(totalMinutes / 60);
    this.minutes = totalMinutes % 60;
  }

  onTimeChange() {
    const totalMinutes = (this.hours || 0) * 60 + (this.minutes || 0);
    this.control.setValue(totalMinutes);
  }
}
